// extracted by mini-css-extract-plugin
module.exports = {"links":"styles_links__ZIFdn","noData":"styles_noData__3OziF","cards":"styles_cards__2sUCD","card":"styles_card__eDhUM"};